import React from 'react';
import Particles from 'react-particles-js';
import ParticlesConfig from '../../shared/assets/particles.json';
import './Particles.css';

const particles = () => {
    return <Particles params={ ParticlesConfig } className="particles" />
}

export default particles;